<template>
    <div class="hello">
        <h1>{{ msg }}</h1>
    
    </div>
</template>

<script>
export default {
    name: 'HelloWorld',
    data () {
        return {
            msg: 'Welcome to Your Vue.js App'
        }
    },
    created: function() {
        this.$router.push({name: "Login"});
        // this.$router.push({name: "ImageUpload"});
    }
}
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/HelloWorld.vue